const RECEIVE_ALL_CHARGEBACK_STATUSES = 'src/chargeBackStatus/RECEIVE_ALL_CHARGEBACK_STATUSES';
const CLEAR_ALL_CHARGEBACK_STATUSES = 'src/chargeBackStatus/CLEAR_ALL_CHARGEBACK_STATUSES';

export default {
  RECEIVE_ALL_CHARGEBACK_STATUSES,
  CLEAR_ALL_CHARGEBACK_STATUSES
};
